import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
};

const productsSlice = createSlice({
  name: "products",
  initialState: initialState,
  reducers: {
    fetchProducts: () => console.log("fetching products..."),
  },
});

export const { fetchProducts } = productsSlice.actions;
export default productsSlice.reducer;
